export const LogoMark = ({ className = "h-12 w-12" }) => (
  <img src="/img/logo.png" alt="Complete Maintenance Services logo" className={`object-contain ${className}`} />
);

export const Wordmark = ({ className = "h-12", fg = "#EDEDED", knock = "#3D3D3D", testId }) => (
  <svg viewBox="0 0 300 222" className={`w-auto ${className}`} role="img" aria-label="Complete Maintenance Services" data-testid={testId}>
    <g fontFamily="Anton, Impact, sans-serif" fill={fg}>
      <text x="8" y="67" textLength="283" lengthAdjust="spacingAndGlyphs">
        <tspan fontSize="77">C</tspan><tspan fontSize="63">OMPLETE</tspan>
      </text>
      <rect x="0" y="76" width="300" height="68" />
      <text x="15" y="133" textLength="271" lengthAdjust="spacingAndGlyphs" fontSize="52" fill={knock}>MAINTENANCE</text>
      <text x="23" y="218" textLength="253" lengthAdjust="spacingAndGlyphs">
        <tspan fontSize="74">S</tspan><tspan fontSize="62">ERVICES</tspan>
      </text>
    </g>
  </svg>
);

export const Logo = ({ onClick }) => (
  <button onClick={onClick} data-testid="nav-logo" className="group flex items-center gap-3 text-left">
    <LogoMark className="h-12 w-12 shrink-0 transition-transform duration-500 group-hover:-rotate-6 group-hover:scale-105 sm:h-14 sm:w-14" />
    <Wordmark className="h-14 sm:h-16" knock="#3D3D3D" testId="nav-wordmark" />
  </button>
);
